import React, { useState } from 'react'
import UserPanelNavbar from './UserPanelNavbar'
import PerfilUser from './PerfilUser'
import FormulariosAdmin from './FormulariosAdmin'
import Renovaciones from './Renovaciones'


const UserDetail = () => {

  const [screen, setScreen] = useState('PerfilUser')
  

  const renderTabContent = () => {
    switch (screen) {
      case 'PerfilUser':
        return <PerfilUser />;
      case 'FormulariosAdmin':
        return <FormulariosAdmin />;
      case 'Renovaciones':
        return <Renovaciones/>  
      default:
        return null;
    }
  };
  
    
  return (
    <div className=''>
       <UserPanelNavbar setScreen={setScreen} />
       {renderTabContent()}
       
    </div>
  )
}

export default UserDetail


